<div class="body">
    <div class="row">
        <div class="col-md-2">
            <label class="catlabel">Alarms Groups:<span class="required">*</span></label>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
            <label class="catlabel">Periods:<span class="required">*</span></label>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
            <label class="catlabel">Domicile(s):<span class="required">*</span></label>
        </div>
        <div class="col-md-2"></div>
    </div>
    <div class="row">
        <div class="col-md-2">
            <div class="alarm-content">
                <mat-form-field appearance="outline" class="fixed-select" style="width: 100%;">

                    <mat-select [(ngModel)]="selectedGroup" placeholder="Select Group"
                        (selectionChange)="onAlarmGroupChange($event)">
                        <mat-option style="background: white;">
                            <ngx-mat-select-search [formControl]="groupFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results found">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let group of filteredGroups | async" [value]="group">
                            {{ group.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
            <div class="alarm-content">
                <mat-form-field appearance="outline" class="fixed-select" style="width: 100%;">

                    <mat-select [(ngModel)]="selectedPeriod" placeholder="Select Period"
                        (selectionChange)="onPeriodChange($event)">
                        <mat-option style="background: white;">
                            <ngx-mat-select-search [formControl]="periodFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results found">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let period of filteredPeriods | async" [value]="period">
                            {{ period.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
            <div class="alarm-content">
                <mat-form-field appearance="outline" class="fixed-select" style="width: 100%;">
                    <mat-select [(ngModel)]="selectedDomiciles" [multiple]="true" placeholder="Select Domicile"
                        (selectionChange)="onDomicileChange($event)">
                        <mat-option style="background: white;">
                            <div
                                style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 1;">
                                <mat-checkbox style="margin-right: 8px;" [checked]="isAllSelected()"
                                    [indeterminate]="isIndeterminate()" (change)="toggleSelectAll($event)">
                                </mat-checkbox>
                                <ngx-mat-select-search [formControl]="domicileFilterCtrl" placeholderLabel="Search"
                                    noEntriesFoundLabel="No options found">
                                </ngx-mat-select-search>
                            </div>
                        </mat-option>
                        <mat-option *ngFor="let d of filteredDomiciles | async" [value]="d" style="font-size: 13px;">
                            {{ d.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-2"></div>
    </div>
    <br>
    <div class="row">
        <div class="col-md-2">
            <label class="catlabel">Alarms Start Date:<span class="required">*</span></label>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
            <label class="catlabel">Alarms End Date:<span class="required">*</span></label>
        </div>
        <div class="col-md-6"></div>
    </div>
    <div class="row">
        <div class="col-md-2">
            <div class="alarm-content">
                <mat-form-field appearance="outline" style="width: 100%;" class="fixed-select">
                    <input matInput [matDatepicker]="startPicker" [(ngModel)]="alarmStartDate">
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
            <div class="alarm-content">
                <mat-form-field appearance="outline" style="width: 100%;" class="fixed-select">
                    <input matInput [matDatepicker]="endPicker" [(ngModel)]="alarmEndDate">
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2" style="align-content: center;">
            <button mat-raised-button class="black-btn" style="margin-left: 0px;" (click)="clear()">CLEAR</button>
            <button mat-raised-button class="black-btn" (click)="runAlarmsJob()">RUN</button>
        </div>
        <div class="col-md-2"></div>
    </div>
    <div *ngIf="this.errorMessage.length > 0" class="row">
        <br>
        <div class="col-md-3"></div>
        <div class="col-md-6">
            <div *ngIf="this.errorMessage.length > 0" class="alert alert-danger" role="alert">
                <mat-icon>thumb_down</mat-icon> &nbsp;
                <label style="vertical-align: text-bottom; margin-bottom: 0rem;">{{errorMessage}}</label>
            </div>
        </div>
        <div class="col-md-3"></div>
        <br>
    </div>
    <div *ngIf="this.successMessage.length > 0" class="row">
        <br>
        <div class="col-md-3"></div>
        <div class="col-md-6">
            <div *ngIf="this.successMessage.length > 0" class="alert alert-success" role="alert">
                <mat-icon>thumb_up</mat-icon> &nbsp;
                <label style="vertical-align: text-bottom; margin-bottom: 0rem;">{{successMessage}}</label>
            </div>
        </div>
        <div class="col-md-3"></div>
        <br>
    </div>
    <header *ngIf="this.alarmsStatsAvaile && this.errorMessage.length === 0">
        <div class="stats_header" style="display:block"></div>
    </header>
    <div *ngIf="this.alarmsStatsAvaile && this.errorMessage.length === 0">
        <app-stats [alarmStats]="alarmStats" [selectedPeriod]="selectedPeriod" [selectedDomiciles]="selectedDomiciles"
            [selectedGroup]="selectedGroup">
        </app-stats>
    </div>
</div>